import React, { useEffect, useMemo, useRef, useState } from "react";
import "./RiskPacketSlider.scss";
import { currencyFormat } from "../../util";
import { Tooltip } from "reactstrap";

interface Props {
  farmValue: number;
  bestValue: number;
  worstValue: number;
  livestockGroup?: "herd" | "flock";
}

export const RiskPacketSlider = ({
  farmValue,
  bestValue,
  worstValue,
  livestockGroup,
}: Props) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [hovered, setHovered] = useState(false);

  const sliderPos = useMemo(() => {
    return clamp(
      ((farmValue - worstValue) / (bestValue - worstValue)) * 100,
      0,
      100
    );
  }, [bestValue, worstValue, farmValue]);

  useEffect(() => {
    targetRef.current?.style.setProperty("--pos", `${sliderPos}%`);
  }, [sliderPos, targetRef.current]);

  if (isNaN(sliderPos)) return null;

  const farmMoney = currencyFormat.format(farmValue);

  return (
    <>
      <div
        className="slider-container"
        ref={containerRef}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onTouchStart={() => setHovered(true)}
        onTouchEnd={() => setHovered(false)}
      >
        <div className="slider-track"></div>
        <div className="slider-dot slider-dot-worst" />
        <div className="slider-dot slider-dot-best" />
        <div className="slider-triangle" ref={targetRef} />
        {/* <div className="slider-dot slider-dot-target" ref={targetRef} /> */}
      </div>
      <small className="text-muted">
        Adjust the forecast parameters to explore how your risk can be managed.
      </small>
      <Tooltip
        target={targetRef}
        container={containerRef}
        placement="top"
        isOpen={hovered}
      >
        Your estimated {livestockGroup} value is {farmMoney}.
      </Tooltip>
    </>
  );
};

const clamp = (value: number, min: number, max: number) =>
  Math.max(Math.min(max, value), min);
